import { useState } from 'react';
import UbbeCardHeader from '../../../../../global-components/cardHeader';
import BCSectionUserInputs from './bcInputs';
import ContactSectionUserInputs from './contactInputs';
import DetailSectionUserInputs from './userInputs';
import EditContactModal from './EditContactModal';
import EditBcModal from './EditBcModal';

interface Props {
  formData: any;
  setFormData: any;
  isEdit: boolean;
  fetchData?: any;
}
function EditAccountUserDetailSection({
  formData,
  setFormData,
  isEdit,
  fetchData,
}: Props) {
  const [editContact, seteditContact] = useState(false);
  const [editBC, setEditBC] = useState(false);
  const onClickContactHandler = () => {
    seteditContact(true);
  };
  function onCloseModal() {
    seteditContact(false);
  }
  const onClickBCtHandler = () => {
    setEditBC(true);
  };
  function onCloseBCModal() {
    setEditBC(false);
  }
  return (
    <>
      <div
        className='row mt-4'
        style={{ padding: '0px 0px 0px 10px', marginLeft: '-6px' }}
      >
        <div className='col-12 col-md-6'>
          <div className='ubbe-card h-100'>
            <UbbeCardHeader headerText='General Information' />

            <div className='card-body   pt-2 p-4 h-auto'>
              {isEdit ? (
                <DetailSectionUserInputs formData={formData} />
              ) : (
                <div
                  id='user_details'
                  style={{ width: '60%' }}
                >
                  <div className='row'>
                    <div className='col'>
                      <span className='global-text-16'> User Name:</span>
                    </div>
                    <div
                      className='col-md-auto boldglobaltext'
                      id='origin_address'
                    >
                      {formData?.username ? formData?.username : 'N/A'}
                    </div>
                  </div>
                  <div className='row mt-3'>
                    <div className='col'>
                      <span className='global-text-16'> Joined:</span>
                    </div>
                    <div
                      className='col-md-auto boldglobaltext'
                      id='origin_address'
                    >
                      {formData?.date_joined ? formData?.date_joined : 'N/A'}
                    </div>
                  </div>
                  <div className='row mt-3'>
                    <div className='col'>
                      <span className='global-text-16'> Last login:</span>
                    </div>
                    <div
                      className='col-md-auto boldglobaltext'
                      id='origin_address'
                    >
                      {formData?.last_login ? formData?.last_login : 'N/A'}
                    </div>
                  </div>
                  <div className='row mt-3'>
                    <div className='col'>
                      <span className='global-text-16'> Rated:</span>
                    </div>
                    <div
                      className='col-md-auto boldglobaltext'
                      id='origin_address'
                    >
                      {formData?.rating ? formData?.rating : 'N/A'}
                    </div>
                  </div>
                  <div className='row mt-3'>
                    <div className='col'>
                      <span className='global-text-16'> Shipped:</span>
                    </div>
                    <div
                      className='col-md-auto boldglobaltext'
                      id='origin_address'
                    >
                      {formData?.shipping ? formData?.shipping : 'N/A'}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='col-12 col-md-6'>
          <div className='ubbe-card h-100'>
            <UbbeCardHeader
              headerText='Contact'
              editable
              onClick={onClickContactHandler}
            />
            <div className='card-body pt-2 p-4 h-auto'>
              {editContact && (
                // <ContactSectionUserInputs
                //   formData={formData}
                //   setFormData={setFormData}
                // />
                <EditContactModal
                  formData={formData}
                  setFormData={setFormData}
                  onClose={onCloseModal}
                  fetchData={fetchData}
                  editContact={seteditContact}
                />
              )}

              <div
                id='contact_details'
                style={{ width: '60%' }}
              >
                <div className='row'>
                  <div className='col'>
                    <span className='global-text-16'> First Name:</span>
                  </div>
                  <div
                    className='col-md-auto boldglobaltext'
                    id='origin_address'
                  >
                    {formData?.first_name ? formData?.first_name : 'N/A'}
                  </div>
                </div>
                <div className='row mt-3'>
                  <div className='col'>
                    <span className='global-text-16'> Last Name:</span>
                  </div>
                  <div
                    className='col-md-auto boldglobaltext'
                    id='origin_address'
                  >
                    {formData?.last_name ? formData?.last_name : 'N/A'}
                  </div>
                </div>
                <div className='row mt-3'>
                  <div className='col'>
                    <span className='global-text-16'> Email Address:</span>
                  </div>
                  <div
                    className='col-md-auto boldglobaltext'
                    id='origin_address'
                  >
                    {formData?.email ? formData?.email : 'N/A'}
                  </div>
                </div>
                <div className='row mt-3'>
                  <div className='col'>
                    <span className='global-text-16'> Phone Number:</span>
                  </div>
                  <div
                    className='col-md-auto boldglobaltext'
                    id='origin_address'
                  >
                    {formData?.phone ? formData?.phone : 'N/A'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='col-12 col-md-6 mt-4'>
        <div className='ubbe-card h-100'>
          <UbbeCardHeader
            headerText='Business Central'
            editable
            onClick={onClickBCtHandler}
          />
          <div className='card-body pt-2 p-4 h-auto'>
            {editBC && (
              // <BCSectionUserInputs
              //   formData={formData}
              //   setFormData={setFormData}
              // />

              <EditBcModal
                formData={formData}
                setFormData={setFormData}
                onClose={onCloseBCModal}
                fetchData={fetchData}
                editContact={setEditBC}
              />
            )}
            <div
              id='bc_details'
              style={{ width: '60%' }}
            >
              <div className='row '>
                <div className='col'>
                  <span className='global-text-16'> BC User Name:</span>
                </div>
                <div
                  className='col-md-auto boldglobaltext'
                  id='origin_address'
                >
                  {formData?.bc_username ? formData?.bc_username : 'N/A'}
                </div>
              </div>
              <div className='row mt-3'>
                <div className='col'>
                  <span className='global-text-16'> BC Location Code:</span>
                </div>
                <div
                  className='col-md-auto boldglobaltext'
                  id='origin_address'
                >
                  {formData?.bc_location_code
                    ? formData?.bc_location_code
                    : 'N/A'}
                </div>
              </div>
              <div className='row mt-3'>
                <div className='col'>
                  <span className='global-text-16'> BC Branch Code::</span>
                </div>
                <div
                  className='col-md-auto boldglobaltext'
                  id='origin_address'
                >
                  {formData?.bc_branch_code ? formData?.bc_branch_code : 'N/A'}
                </div>
              </div>
              <div className='row mt-3'>
                <div className='col'>
                  <span className='global-text-16'>BC Cost Center:</span>
                </div>
                <div
                  className='col-md-auto boldglobaltext'
                  id='origin_address'
                >
                  {formData?.bc_cost_centre ? formData?.bc_cost_centre : 'N/A'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditAccountUserDetailSection;
